export default "__VITE_ASSET__1MhT5Kf4__"